var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.273,
    height: 24.792,
    viewBox: "0 0 29.273 24.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.6;}.b{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.4,29.4a1.288,1.288,0,0,1-.194-1.184,10.4,10.4,0,0,1,9.893-6.9A10.243,10.243,0,0,1,18.9,23.1a1.368,1.368,0,0,0,1.879-.328,1.3,1.3,0,0,0-.335-1.84,12.918,12.918,0,0,0-2.692-1.407,6.632,6.632,0,0,0,1.762-7.5A6.9,6.9,0,0,0,13.131,7.8,6.821,6.821,0,0,0,6.247,14.54,6.663,6.663,0,0,0,8.476,19.5,12.838,12.838,0,0,0,.638,27.41a3.86,3.86,0,0,0,.583,3.55,4.036,4.036,0,0,0,3.272,1.63H16.235a1.336,1.336,0,0,0,1.35-1.322S3.659,29.749,3.4,29.4Zm9.729-18.961a4.1,4.1,0,1,1-4.184,4.1A4.146,4.146,0,0,1,13.131,10.442Z",
    transform: "translate(-0.44 -7.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M278.335,322.587a1.27,1.27,0,0,0-1.772.293l-6.26,8.744a.725.725,0,0,1-1.044.054l-4.052-3.891a1.27,1.27,0,0,0-1.759,1.832l4.057,3.9a3.275,3.275,0,0,0,2.253.9q.108,0,.216-.007a3.274,3.274,0,0,0,2.328-1.213c.015-.018.029-.037.043-.056l6.285-8.779A1.27,1.27,0,0,0,278.335,322.587Z",
    transform: "translate(-249.593 -310.677)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowersIcon);
export default __webpack_public_path__ + "static/media/followers-icon.727f3b2d355ef2f23151cbdd2afaa34e.svg";
export { ForwardRef as ReactComponent };